import ApplicationController from './application_controller'

// HoverOverlayController works using an already-present overlay target inside of event.currentTarget
export default class extends ApplicationController {

	static targets = [ 'overlay' ]

	connect() {
		this.element.style.position = 'relative'
		this.removeOverlay()
	}

	disconnect() {
		this.removeOverlay()
	}

	addOverlay(_event) {
		this.showOverlayElement()
	}

	removeOverlay(_event) {
		this.hideOverlayElement()
	}

	showOverlayElement() {
		this.overlayTarget.classList.remove('d-none')
	}

	hideOverlayElement() {
		this.overlayTarget.classList.add('d-none')
	}

}
